/**
 * Ограничение параллельной загрузки изображений: по умолчанию строго по одной за раз
 * (следующая начинается после load/error предыдущей). Слот освобождается в onLoad/onError <img>.
 */

/** Параллельных загрузок превью (1 = очень медленно на страницах с десятками картинок). */
const DEFAULT_MAX = 4;
let maxConcurrent = DEFAULT_MAX;
let active = 0;
const waiters = [];

function tryDrain() {
  while (active < maxConcurrent && waiters.length) {
    const { resolve, token } = waiters.shift();
    active += 1;
    resolve(token);
  }
}

/**
 * @returns {Promise<{ release: () => void }>} release вызвать после onLoad/onError img
 */
export function acquireImageLoadSlot() {
  return new Promise((resolve) => {
    const token = {
      release: () => {
        active = Math.max(0, active - 1);
        tryDrain();
      },
    };
    if (active < maxConcurrent) {
      active += 1;
      resolve(token);
    } else {
      waiters.push({ resolve, token });
    }
  });
}

/** Для тестов или тонкой настройки (например max=2 на мобильных). */
export function setImageLoadConcurrency(n) {
  maxConcurrent = Math.max(1, Math.min(8, Number(n) || DEFAULT_MAX));
}
